import AdUtils from '../../../../shared/utils/ads';
import FlavourConfig from '../../../../shared/config/flavours';
import Focus from '../../../../shared/types/enums/focus';
import Pages from '../../../../shared/types/enums/pages';
import Sections from '../../../../shared/types/enums/sections';
import Storage from '../../../../shared/utils/storage';
import TAccess from '../../templates/access';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import useTranslationRefresh from '../../../../shared/components/utils/hooks/useTranslationRefresh';
import { pushRoute } from '../../../../shared/store/thunks/route.thunk';
import { setVideoAd } from '../../../../shared/store/slices/ads.slice';
import { setFocus } from '../../../../shared/store/slices/focus.slice';
import { useAppDispatch } from '../../../../shared/store/hooks';
import { useCallback } from 'react';

function LanguagesSelection() {
  const dispatch = useAppDispatch();
  const firstLoad = Storage.get('first_load') === '1';
  const buttonText = TranslationManager.get(
    `PAGES.ACCESS.LANGUAGES.BUTTON.${firstLoad ? 'CONTINUE' : 'LINK'}`
  );
  const description = TranslationManager.get(
    'PAGES.ACCESS.LANGUAGES.DESCRIPTION'
  );
  const title = TranslationManager.get('PAGES.ACCESS.LANGUAGES.TITLE');

  const action = useCallback(() => {
    if (firstLoad) {
      Storage.set('first_load', '0');
      const adSource = AdUtils.getSource(Sections.START_APP);
      dispatch(pushRoute({ route: { Page: Pages.INITIAL, overwrite: true } }));
      dispatch(setFocus(Focus.MENU));
      if (adSource) {
        dispatch(setVideoAd(adSource));
      }
    } else {
      dispatch(pushRoute({ route: { Page: Pages.LINK, overwrite: true } }));
    }
  }, [firstLoad]);

  const returnAction = () => {
    dispatch(pushRoute({ route: { Page: Pages.WELCOME, overwrite: true } }));
  };

  useTranslationRefresh();

  return (
    <TAccess
      action={action}
      buttonText={buttonText}
      description={description}
      languages={FlavourConfig.languages}
      returnAction={returnAction}
      title={title}
    />
  );
}

export default LanguagesSelection;
